import React, { useContext } from "react";
import { InputAdornment, TextField } from "@mui/material";
import FontDownloadIcon from "@mui/icons-material/FontDownload";
import { useSelector } from "react-redux";
import { ModuleContext } from "../utils/Constants";
import { isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";

export default function SaitTextField(props) {
	const { noAutocomplete, password, searchWindow, name, ...textProps } = props;
	const defaultSize = "small";

	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === textProps.objmod);

	const [isCapsLockOn, setIsCapsLockOn] = React.useState(false);

	const checkCapsLock = (event) => {
		if (event.getModifierState("CapsLock")) {
			setIsCapsLockOn(true);
		} else {
			setIsCapsLockOn(false);
		}
	};

	return isComponentVisible(objMod, textProps.hidden) ? (
		<TextField
			{...textProps}
			name={Array.isArray(name) ? name[0] : name}
			type={textProps.type ? textProps.type : password ? "password" : "text"}
			size={textProps.size || defaultSize}
			onKeyDown={(event) => {
				event.stopPropagation();
				textProps.onKeyDown ? textProps.onKeyDown(event) : password ? checkCapsLock(event) : null;
			}}
			disabled={isComponentDisabled(objMod, textProps.disabled)}
			sx={{
				...textProps.sx,
				...(!searchWindow && {
					"& .MuiOutlinedInput-root.Mui-disabled": {
						backgroundColor: "#f0f0f0",
						borderRadius: 1,
					},
				}),
				"& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input.Mui-disabled": {
					color: "#212121", // colore testo più scuro
					WebkitTextFillColor: "#212121", // forza colore su Chrome/Edge
				},
				"& .MuiInputLabel-root.Mui-disabled": {
					color: "#424242",
				},
				background: props.backgroundColor,
			}}
			slotProps={{
				input: {
					endAdornment: textProps.endadornment,
					startAdornment: textProps.startadornment,
					...(password && isCapsLockOn
						? {
								endAdornment: (
									<InputAdornment position="end">
										<FontDownloadIcon />
									</InputAdornment>
								),
						  }
						: {}), // Un oggetto vuoto se la condizione non è soddisfatta
				},

				htmlInput: {
					minLength: textProps.minLength,
					maxLength: textProps.maxLength,
					autoComplete: noAutocomplete ? "new-password" : null,
					...(props.type === "number" && textProps.maxLength
						? {
								onInput: (e) => {
									if (e.target.value.length > e.target.maxLength) {
										e.target.value = e.target.value.slice(0, e.target.maxLength);
									}
								},
						  }
						: {}),
				},
			}}
		/>
	) : null;
}
